export default __webpack_public_path__ + "static/embarkable-connect-478f4830d228c6669853fde45cb08307.webp";